<template>
  <div class="flex flex-row h-full">
    <div class="offer flex flex-col justify-between">
      <div class="flex flex-col space-y-4 items-start overflow-y-auto p-6">
        <slot name="offer" />
      </div>
      <div class="px-6 pt-4 pb-6">
        <slot name="action" />
      </div>
    </div>
    <div
      class="offer-image hidden md:block"
      :class="backgroundColor"
      :style="offerImage"
    >
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'


export default defineComponent({
  props: {
    image: {
      type: String,
      default: 'offer'
    },
    backgroundColor: {
      type: String,
      default: 'bg-teal-400'
    },
  },

  setup (props) {
    
    const offerImage = computed(() => {
      const image = require(`@/assets/img/${props.image}.png`)
      return `background-image: url('${image}')`
    })

    return {
      offerImage
    }
  }
})
</script>

<style scoped>
@layer components {
  .offer {
    @apply w-full md:max-w-md;
  }

  .offer-image {
    @apply bg-cover bg-no-repeat bg-center w-full;
  } 
}
</style>